export default __webpack_public_path__ + "static/industry-solutions-hero-robot-6e240caad115f6c622d56d77aa4373f7.png";